/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'accounts_payable_number': 'Kreditorennummer',
    'accounts_receivable_number': 'Debitorennummer',
    'add_address': 'Adresse hinzufügen',
    'address_created': 'Adresse gespeichert',
    'auto_generate_customer_number': 'Kundennummer automatisch generieren',
    'business_partner': 'Geschäftspartner',
    'business_partner_type': 'Typ',
    'business_partner_type_customer': 'Kunde',
    'business_partner_type_customer_and_supplier': 'Kunde und Lieferant',
    'business_partner_type_other': 'Sonstige',
    'business_partner_type_supplier': 'Lieferant',
    'confirm_checked_partner_delete_body': 'Möchtest du die ausgewählten Geschäftspartner wirklich löschen? Alle Rechnungen dieses Geschäftspartner werden festgeschrieben und können nicht mehr bearbeitet werden.',
    'confirm_checked_partnerdelete_title': 'Ausgewählte Geschäftspartner löschen?',
    'confirm_partner_delete_body': 'Möchtest du den Geschäftspartner "{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_partner_delete_title': 'Geschäftspartner löschen?',
    'contact': 'Kontakt | Kontakte',
    'contact_person': 'Kontaktperson | Kontaktpersonen',
    'create_contact_person': 'Kontaktperson anlegen',
    'create_partner': 'Geschäftspartner anlegen',
    'customer': 'Kunde | Kunden',
    'delete_contact_person_text': 'Möchtest du die ausgewählte Kontaktperson wirklich löschen?',
    'delete_contact_person_title': 'Ausgewählte Kontaktperson löschen?',
    'export_partner_modal_body': 'Wähle ein Format in dem die Geschäftspartner exportiert werden sollen.',
    'export_partner_modal_title': 'Geschäftspartner exportieren',
    'make_private': 'Privat schalten',
    'make_public': 'Öffentlich machen',
    'name': 'Name',
    'no_contact_person': 'Keine Kontaktpersonen vorhanden',
    'no_customers': 'Keine Kunden vorhanden',
    'no_notes': 'Keine Notizen vorhanden',
    'no_partners': 'Keine Geschäftspartner vorhanden',
    'note': 'Notiz | Notizen',
    'partner_not_found_notification': 'Der Geschäftspartner wurde nicht gefunden.',
    'partners_deleted': 'Geschäftspartner wurden gelöscht.',
    'write_note': 'Notiz erstellen...'
  },

  /* english */
  en: {
    'accounts_payable_number': 'Accounts payable number',
    'accounts_receivable_number': 'Accounts receivable number',
    'add_address': 'Add address',
    'address_created': 'Address saved',
    'auto_generate_customer_number': 'Generate Customer Number',
    'business_partner': 'Business Partner | Business Partners',
    'business_partner_type': 'Type',
    'business_partner_type_customer': 'Customer',
    'business_partner_type_customer_and_supplier': 'Customer and Supplier',
    'business_partner_type_other': 'Other',
    'business_partner_type_supplier': 'Supplier',
    'confirm_checked_partner_delete_body': 'Do you really want to delete the selected business partners? All invoices of the business partners will be committed and can no longer be edited.',
    'confirm_checked_partner_delete_title': 'Delete selected business partner?',
    'confirm_partner_delete_body': 'Do you really want to delete "{name}"? This action can not be undone!',
    'confirm_partner_delete_title': 'Delete Customer?',
    'contact': 'Contact | Contacts',
    'contact_person': 'Contact person | Contact persons',
    'create_contact_person': 'Create contact person',
    'create_partner': 'Create partner',
    'customer': 'Customer | Customers',
    'delete_contact_person_text': 'Do you really want to delete the selected contact person?',
    'delete_contact_person_title': 'Delete selected contact person?',
    'export_partner_modal_body': 'Pick a format to export your partners.',
    'export_partner_modal_title': 'Export partners',
    'make_private': 'Make Private',
    'make_public': 'Make Public',
    'name': 'Name',
    'no_contact_person': 'No contact person available',
    'no_customers': 'No customers available',
    'no_notes': 'No notes stored',
    'no_partners': 'No partners available',
    'note': 'Note | Notes',
    'partner_not_found_notification': 'The buisness partner was not found.',
    'partners_deleted': 'Customers were deleted.',
    'write_note': 'Type a note...'
  }
}
